//Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
import { memo, useCallback, useEffect, useState } from 'react';
import { BzButton, BzChip, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../components';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../redux/actions/modals';
import { setDontMissSearchByDropdown } from '../../redux/actions/dontMiss';

const FilterModalPortfolio = ({ arrDontMissEvents, ...props }) => {


    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const arrSearchDontMissByDropdown = useSelector(state => state?.dontMiss?.arrSearchDontMissByDropdown);

    const [arrSelectedEvents, setSelectedEvents] = useState([]);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    const handleFilterInputs = useCallback((selectedEvent) => {
        let selectedEventsCopy = arrSelectedEvents;
        let nIndex = selectedEventsCopy?.findIndex((eachEvent) => (eachEvent?.toLowerCase() === selectedEvent?.event?.toLowerCase()));

        if (nIndex >= 0) {
            selectedEventsCopy?.splice(nIndex, 1);
            setSelectedEvents([...selectedEventsCopy]);
        } else {
            selectedEventsCopy?.push(selectedEvent?.event);
            setSelectedEvents([...selectedEventsCopy]);
        }
    }, [arrSelectedEvents]);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End

    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    useEffect(() => {
        setSelectedEvents([...arrSearchDontMissByDropdown]);
    }, [arrSearchDontMissByDropdown]);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End

    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    const handleClose = useCallback(() => {
        dispatch(handleModal([{ "PORTFOLIO_DONT_MISS_FILTERS": false }]));
    }, [dispatch]);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End

    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    const handleResetObjFilters = useCallback(() => {
        setSelectedEvents([]);
    }, []);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-Start
    const handleOnFilterApply = useCallback(() => {
        dispatch(setDontMissSearchByDropdown([...arrSelectedEvents]));
        dispatch(handleModal([{ "PORTFOLIO_DONT_MISS_FILTERS": false }]));
    }, [arrSelectedEvents, dispatch]);
    //Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End
    return (
        <BzModal size='md' show={modals['PORTFOLIO_DONT_MISS_FILTERS']} onHide={handleClose}>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>Filters</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='multi-chips-wrap'>
                            {arrDontMissEvents?.length > 0 && arrDontMissEvents?.map((eachEvent) => (
                                <BzChip onClick={() => { handleFilterInputs(eachEvent); }} className={`multi-chip me-2 mb-3 text-capitalize ${arrSelectedEvents?.some((objEachEvent) => objEachEvent?.toLowerCase() === eachEvent?.event?.toLowerCase()) ? 'active' : ''}`}>{eachEvent?.event}</BzChip>
                            ))}
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='m-0 p-0'>
                    <Row className='g-0 pb-2'>
                        <Col className='d-flex justify-content-end aign-items-center'>
                            <BzButton className='btn btn-outline font-size2' disabled={arrSelectedEvents?.length === 0} onClick={(e) => handleResetObjFilters()}>Reset Filters</BzButton>
                            <BzButton className='btn btn-primary font-size2 ms-3' onClick={(e) => handleOnFilterApply()}>Apply</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal >
    );
};

export default memo(FilterModalPortfolio);
//Ameersha N -09-01-2024 - BREEZE -- BT-117134-Breeze Portfolio - Holdings - Don't Miss-End